import { CommonModule } from "@angular/common";
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from "@angular/core";
import { FormGroupDirective } from "@angular/forms";
import {
  SedsFormFieldDropdownModule,
  SedsFormFieldSearchModule,
} from "experian-design-system"; // NOSONAR

import { SharedModule } from "../../../../../shared/shared.module";
import { SearchFormComponent } from "./search-form.component";

@NgModule({
  declarations: [SearchFormComponent],
  imports: [
    CommonModule,
    SharedModule,
    SedsFormFieldSearchModule,
    SedsFormFieldDropdownModule,
  ],
  exports: [SearchFormComponent],
  providers: [FormGroupDirective],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class SearchFormModule {}
